import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useEventListener } from '@websolutespa/bom-mixer-hooks';
import { motion } from 'framer-motion';
import { useRef, useId, useMemo, useCallback, useEffect } from 'react';
import { v4 } from 'uuid';
import { useActions } from '../../../useLlm/useActions.js';
import { Chunk } from '../Chunk/chunk.js';

const ChunkWrapper = _a => {
  var {
      className,
      stream
    } = _a,
    props = __rest(_a, ["className", "stream"]);
  const ref = useRef(null);
  const id = useId();
  const chunkId = `chunk-${id}`;
  const actions = useMemo(() => {
    return (props.item.actions || []).map(x => {
      x.id = x.id || v4();
      return x;
    });
  }, [props.item]);
  // console.log('ChunkWrapper.actions', actions);
  const {
    setWrapperNode
  } = useActions();
  const onScroll = useCallback(() => {
    const node = ref.current;
    if (node) {
      if (node.offsetHeight > 1, node.offsetTop - window.scrollY < window.innerHeight / 2 && node.offsetTop + node.offsetHeight - window.scrollY > window.innerHeight / 2) {
        // console.log(node.id, node.offsetTop - window.scrollY, node.offsetTop + node.offsetHeight - window.scrollY);
        // console.log('ChunkWrapper.id', node.id);
        setWrapperNode(node);
      }
    }
  }, [setWrapperNode]);
  useEventListener('scroll', onScroll);
  useEffect(() => {
    if (ref.current && props.chunkIndex === 0 && props.index === props.total - 1) {
      // console.log('scrollIntoView', USE_SCROLL_INTO_VIEW, ref.current, props);
      ref.current.scrollIntoView({
        behavior: 'instant',
        block: 'start',
        inline: 'start'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const classNames = getClassNames(className || `llm__inner llm__inner--${props.item.type}`);
  // console.log('ChunkWrapper.actions', actions);
  return jsx("div", {
    ref: ref,
    id: chunkId,
    className: classNames,
    "data-message-role": props.role,
    "data-message-index": props.index,
    "data-chunk-index": props.chunkIndex,
    "data-chunk-type": props.item.type,
    "data-actions": JSON.stringify(actions),
    children: stream ? jsx(motion.div, {
      initial: {
        opacity: 0,
        y: 10
      },
      animate: {
        opacity: 1,
        y: 0
      },
      transition: {
        duration: 1
      },
      children: jsx(Chunk, Object.assign({}, props))
    }) : jsx(Chunk, Object.assign({}, props))
  });
};

export { ChunkWrapper };
//# sourceMappingURL=chunk-wrapper.js.map
